import React from 'react';

export default function DrawerFooterActions({ onClose, onExport }) {
  return (
    <div className="mt-4 flex items-center justify-end gap-2 border-t border-slate-200 pt-3 dark:border-slate-800">
      <button
        type="button"
        onClick={onClose}
        className="rounded-md border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
      >
        Kapat
      </button>
      {typeof onExport === 'function' ? (
        <button
          type="button"
          onClick={onExport}
          className="rounded-md bg-primary px-3 py-1.5 text-xs font-bold text-white hover:brightness-110"
        >
          Detayı Dışa Aktar
        </button>
      ) : null}
    </div>
  );
}
